module.exports = __webpack_public_path__ + "media/images/emblems/Dulliken-blason-caca545dc25aeee03f89a39e67181f33.png";